import React, { useState } from "react";
import "./Releases.css";
import { useEffect } from "react";
import client from "../../sanityClient";

// const videos = [
//   { id: "xr-oMoqjLZo", title: "YouTube video player" },
//   { id: "YVqxIB8prpg", title: "AI and Human Consciousness & Society, Rajeev Sangal, Institute Lecture, IIT Delhi, 16 Oct 2024" },
// ];

export default function PodcastList() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    client.fetch(`*[_type == "podcastVideo"]{
      title,
      videoId,
    }`).then((data) => setVideos(data));
  }, []);

  return (
    <section className="podcast_section">
      {videos.map((video, index) => (
        <LazyVideo key={index} videoId={video.videoId} title={video.title} />
      ))}
    </section>
  );
}

const LazyVideo = ({ videoId, title }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="podcast_item">
      {!loaded ? (
        <div className="thumbnail-container" onClick={() => setLoaded(true)}>
          <img
            className="thumbnail"
            src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
            alt={title}
          />
          <div className="play-button">▶</div>
        </div>
      ) : (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          loading="lazy"
        ></iframe>
      )}
    </div>
  );
};
